<footer class="dock-footer">
  <nav class="dock-nav">

    <a routerLink="/clinic" routerLinkActive="active" class="dock-item">
      <span class="active-bg"></span>
      <span class="dock-icon">
        <img src="/assets/e-commerce/icons/93.webp" alt="{{ 'clinic' | transloco }}" />
      </span>
      <span class="dock-label">{{ "clinic" | transloco }}</span>
    </a>

        <a routerLink="/myclinicservices" routerLinkActive="active" class="dock-item">
      <span class="active-bg"></span>
      <span class="dock-icon">
        <img src="/assets/e-commerce/icons/95.webp" alt="{{ 'myclinicservices' | transloco }}" />
      </span>
      <span class="dock-label">{{ "myclinicservices" | transloco }}</span>
    </a>
    
    
    <a routerLink="/Home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="dock-item">
      <span class="active-bg"></span>
      <span class="dock-icon">
        <img src="/assets/e-commerce/icons/62.webp" alt="{{ 'shopping' | transloco }}" />
      </span>
      <span class="dock-label">{{ "shopping" | transloco }}</span>
    </a>

    <a routerLink="/Myorders" routerLinkActive="active" class="dock-item">
      <span class="active-bg"></span>
      <span class="dock-icon">
        <img src="/assets/e-commerce/icons/50.webp" alt="{{ 'myorders' | transloco }}" />
      </span>
      <span class="dock-label">{{ "myorders" | transloco }}</span>
    </a>

    <a routerLink="/cart" routerLinkActive="active" class="dock-item">
      <span class="active-bg"></span>
      <span class="dock-icon cart-wrap">
        @if(cartCount > 0){
        <img src="/assets/e-commerce/icons/45.webp" alt="{{ 'Cart' | transloco }}" />
        }
        @else{
        <img src="/assets/e-commerce/icons/44.webp" alt="{{ 'Cart' | transloco }}" />
        }

        <span class="cart-badge" *ngIf="cartCount > 0">
          {{ cartCount > 99 ? '99+' : cartCount }}
        </span>
      </span>
      <span class="dock-label">{{ "Cart" | transloco }}</span>
    </a>

  </nav>
</footer>